"use client";

// app/blog/_components/SearchBar.tsx

import { useRouter } from "next/navigation";
import { useState } from "react";
import { SearchIcon } from "./icons";

export function SearchBar() {
  const router = useRouter();
  const [q, setQ] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const query = q.trim();
    if (!query) return;
    router.push(`/blog/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <form className="lx-search" onSubmit={submit} role="search">
      <SearchIcon size={20} strokeWidth={2.2} />
      <input
        type="search"
        placeholder="Search articles, guides, languages..."
        aria-label="Search articles"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      <button type="submit">Search</button>
    </form>
  );
}
